import { useQuery } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

import type { RequestLog } from './useRequests';

export interface Change {
  _id: string;
  requestId?: string;
  sessionId?: string;
  documentId: string;
  operationType: string;
  collectionName: string;
  changes?: Record<string, any>;
  createdAt: Date;
  updatedAt: Date;
}

export interface TimelineEvent {
  type: 'request' | 'external-call' | 'db-change';
  title: string;
  timestamp: Date;
  data: any;
}

export interface RequestDetailsResponse {
  request: RequestLog;
  externalCalls: RequestLog[];
  dbChanges: Change[];
  timeline: TimelineEvent[];
}

export const useRequestDetails = (requestId: string | null) => {
  return useQuery({
    queryKey: ['admin-request-details', requestId],
    queryFn: async (): Promise<RequestDetailsResponse> => {
      try {
        return await request({
          path: `admin/requests/${requestId}/details`,
          method: 'GET',
          authenticate: true,
        });
      } catch (error) {
        showErrorToast(error, 'Failed to fetch request details');
        throw error;
      }
    },
    enabled: !!requestId,
  });
};
